import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Card } from "../components/ui/card";
import api, { formatApiError } from "../lib/api";

export default function ChangePassword() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const errs = {};
    if (!current) errs.current = "Inserisci la password attuale.";
    if (next.length < 8) errs.next = "La nuova password deve avere almeno 8 caratteri.";
    if (next && confirm && next !== confirm) errs.confirm = "Le password non coincidono.";
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    setSubmitting(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      await refreshUser();
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Card className="bg-surface border border-border rounded-xl shadow-sm p-8">
          <h1 className="text-xl font-medium text-text-primary mb-1 tracking-tight">Cambia password</h1>
          <p className="text-sm text-text-secondary mb-6">
            {user?.must_change_password
              ? "Al primo accesso è richiesto il cambio della password."
              : "Aggiorna la tua password."}
          </p>
          <form onSubmit={onSubmit} className="space-y-4" data-testid="change-password-form">
            <div className="wl-field">
              <label htmlFor="cp-current" className="wl-label wl-label--required">Password attuale</label>
              <input
                id="cp-current"
                type="password"
                data-testid="cp-current"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                required
                autoComplete="current-password"
                className={`wl-input ${errors.current ? "is-error" : ""}`}
                aria-invalid={!!errors.current}
              />
              {errors.current && <span className="wl-error-msg">{errors.current}</span>}
            </div>
            <div className="wl-field">
              <label htmlFor="cp-new" className="wl-label wl-label--required">Nuova password</label>
              <input
                id="cp-new"
                type="password"
                data-testid="cp-new"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
                className={`wl-input ${errors.next ? "is-error" : ""}`}
                aria-invalid={!!errors.next}
              />
              {errors.next
                ? <span className="wl-error-msg">{errors.next}</span>
                : <span className="wl-helper">Almeno 8 caratteri. Meglio se includi maiuscole, numeri e simboli.</span>}
            </div>
            <div className="wl-field">
              <label htmlFor="cp-confirm" className="wl-label wl-label--required">Conferma nuova password</label>
              <input
                id="cp-confirm"
                type="password"
                data-testid="cp-confirm"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                autoComplete="new-password"
                className={`wl-input ${errors.confirm ? "is-error" : ""}`}
                aria-invalid={!!errors.confirm}
              />
              {errors.confirm && <span className="wl-error-msg">{errors.confirm}</span>}
            </div>
            {error && (
              <div data-testid="change-password-error"
                className="text-sm text-danger bg-danger-subtle border border-danger-subtle px-3 py-2 rounded-lg">{error}</div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="cp-submit"
              className="wl-btn wl-btn--primary w-full"
            >
              {submitting ? "Salvataggio…" : "Aggiorna password"}
            </button>
          </form>
        </Card>
      </div>
    </div>
  );
}
